export default "__VITE_ASSET__7zjr1Ty5__"